const getFormsURL = () => {
    let url = 'https://' + window.location.hostname
    // For Debugging:
    if (window.location.hostname.toUpperCase().includes('LOCALHOST'))
        url = 'https://nettest.awc-inc.com'

    return url
}

export const loginFormsRedirect = (url) => {
    window.location = `${getFormsURL()}/masterclient/main.aspx?redirect=${encodeURIComponent(
        `${getFormsURL()}${url}`
    )}`
}
